import { render } from "./KitchenOrdersPage.vue?vue&type=template&id=1081b08a&scoped=true"
import script from "./KitchenOrdersPage.vue?vue&type=script&lang=js"
export * from "./KitchenOrdersPage.vue?vue&type=script&lang=js"

import "./KitchenOrdersPage.vue?vue&type=style&index=0&id=1081b08a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1081b08a"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtnGroup,QBtn,QSeparator});
